import React, { useState, useEffect, ReactElement } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { HEADER_MOBILE_BREAKPOINT, TASK_LIST_MENU_ITEMS, TASK_LIST_URL_PARAMS } from '../../../constants/constants';

import { Menu } from './styles';
import { NavLink } from 'react-router-dom';
import Routes from '../../../constants/routes';
import { CUSTOMER_ROLES } from '../../../constants/roles';

const CustomerMenu = (props: any): ReactElement => {
	const maxLength = 20;
	const customerAdminRoles = [CUSTOMER_ROLES.Admin.name, CUSTOMER_ROLES.Moderator.name, CUSTOMER_ROLES.Owner.name];
	const [windowWidth, setWindowWidth] = useState(window.innerWidth);

	const isCompact = (): boolean => {
		return windowWidth < HEADER_MOBILE_BREAKPOINT;
	};

	const isAdmin = (): boolean => {
		return customerAdminRoles.includes(props.user.customerRole);
	};

	const hasMultipleLocations = (): boolean => {
		return props.user.hasMultipleLocations;
	};

	// Function to update window width state
	const updateWindowWidth = () => {
		setWindowWidth(window.innerWidth);
	};

	const truncateString = (str: string, maxLength: number) => {
		if (str.length > maxLength) {
			return str.slice(0, maxLength) + '...';
		}
		return str;
	};

	const buildQueryParams = (params: any) => {
		const searchParams = new URLSearchParams();

		Object.entries(params).forEach(([key, value]) => {
			const shortKey = TASK_LIST_URL_PARAMS[key] || key;

			if (Array.isArray(value)) {
				(value as any[]).forEach((v) => searchParams.append(shortKey, v));
			} else {
				searchParams.append(shortKey, value as string);
			}
		});

		return searchParams.toString();
	};

	const goToTasksWithParams = (e: React.MouseEvent) => {
		e.preventDefault();

		if (props.locationTaskActions) {
			props.locationTaskActions.setTasksMenuSelected(TASK_LIST_MENU_ITEMS.Tasks.value);
		}

		const tasksMenuItems = props.taskListState?.tasksMenuItems || props.tasksMenuItems || [];
		const menuItem = tasksMenuItems.find((x: any) => x.value === TASK_LIST_MENU_ITEMS.Tasks.value);

		if (menuItem?.urlParams) {
			const queryString = buildQueryParams(menuItem.urlParams);
			props.history.push(`${Routes.Tasks}?${queryString}`);
		} else {
			props.history.push(Routes.Tasks);
		}

		// Close the menu after navigation
		if (props.onCancelClick) {
			props.onCancelClick();
		}
	};

	const onNavLinkClick = (event) => {
		props.closeUserMenu();
		// If you want to prevent default navigation, uncomment the line below
		// event.preventDefault(); 
	};

	// Add event listener when component mounts
	useEffect(() => {
		window.addEventListener('resize', updateWindowWidth);

		// Remove event listener when component unmounts
		return () => {
			window.removeEventListener('resize', updateWindowWidth);
		};
	}, []);

	return (
		<Menu>
			<ul className='menu-items'>
				{isCompact() && (
					<>
						{hasMultipleLocations() && (
							<li>
								<i className='fa-regular fa-display-chart-up'></i>
								<NavLink to={Routes.DashboardCorporate}>Company Summary</NavLink>
							</li>
						)}
						<li>
							<i className='fa-regular fa-chart-simple'></i>
							<NavLink to={Routes.DashboardLocation}>Dashboard</NavLink>
						</li>
						<li>
							<i className='fa-regular fa-list-check'></i>
							<a href='#' onClick={goToTasksWithParams}>
								Tasks
							</a>
						</li>
						<li>
							<i className='fa-regular fa-file-chart-column'></i>
							<NavLink to={Routes.Reports}>Reports</NavLink>
						</li>
						{isAdmin() && (
							<li>
								<i className='fa-light fa-gear'></i>
								<NavLink to={Routes.AdminHome}>Settings / Admin</NavLink>
							</li>
						)}
					</>
				)}
				<li>
					<i className='fa-regular fa-user'></i>
					<NavLink to={Routes.ProfileUser} onClick={onNavLinkClick}>Profile</NavLink>
				</li>
				<li>
					<i className='fa-regular fa-envelope'></i>
					<NavLink to={Routes.ProfileNotifications} onClick={onNavLinkClick}>Email Notifications</NavLink>
				</li>
				{props.isSSOUser == false && (
					<li>
						<i className='fa-regular fa-id-card'></i>
						<a href='#' onClick={props.onAddSubscription}>
							Add Subscription
						</a>
					</li>
				)}

				<li>
					<i className='fa-regular fa-circle-question'></i>
					<a href='https://ehsolution.zendesk.com/hc/en-us'>FAQ & Tutorials</a>
				</li>
				<li>
					<i className='fa-regular fa-headset'></i>
					<a href='#' onClick={props.showSupportDrawer}>
						Support
					</a>
				</li>
				<hr />
				{props.user.activeUserSubscriptions && (
					<li>
						<i className='fa-regular fa-arrows-rotate'></i>
						<select name='subscriptions' onChange={props.onChangeSubscription} value={props.user.currentSubscriptionId.toString()}>
							{props.user.activeUserSubscriptions.map((option) => (
								<option key={option.id} value={option.id} title={option.name}>
									{truncateString(option.name, maxLength)}
								</option>
							))}
						</select>
					</li>
				)}
				{isAdmin() && (
					<li>
						<i className="fa-light fa-gear"></i>
						<NavLink to={Routes.AdminHome} onClick={onNavLinkClick}>Settings / Admin</NavLink>
					</li>
				)}
				<li>
					<i className='fa-regular fa-power-off'></i>
					<NavLink to={Routes.LogoutPage} onClick={onNavLinkClick}>Sign Out</NavLink>
				</li>
			</ul>
		</Menu>
	);
};

function mapStateToProps(state: any) {
	let tasksMenuItems = [];
	if (state.taskListState && state.taskListState.tasksMenuItems && state.taskListState.tasksMenuItems.length) {
		tasksMenuItems = state.taskListState.tasksMenuItems;
	}

	return {
		user: state.user,
		taskListState: state.taskListState,
		tasksMenuItems: tasksMenuItems,
	};
}

export default withRouter(connect(mapStateToProps)(CustomerMenu));
